export const collection = [
  {
    "id": "17",
    "name": "Lightweight Linen Shirt",
    "description": "Stay cool and stylish with our lightweight linen shirt.",
    "brand": "SummerBreeze",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Skyblue",
    "color2": "Beige",
    "image": "Lightweight Linen Shirt.jpg",
    "price": "3999"
  },
  {
    "id": "18",
    "name": "Flowy Maxi Dress",
    "description": "Make a statement with our flowy maxi dress.",
    "brand": "SunnyStyle",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Coral",
    "color2": "Yellow",
    "image": "Flowy Maxi Dress.avif",
    "price": "5999"
  },
  {
    "id": "19",
    "name": "Denim Shorts",
    "description": "Classic denim shorts for a casual summer look.",
    "brand": "BeachLife",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Lightblue",
    "color2": "White",
    "image": "Denim Shorts.jpg",
    "price": "2999"
  },
  {
    "id": "20",
    "name": "Sun Hat",
    "description": "Protect yourself from the sun with our stylish sun hat.",
    "brand": "SunSeeker",
    "size1": "One Size",
    "color1": "Natural",
    "color2": "Straw",
    "image": "Sun Hat.jpg",
    "price": "1999"
  },
  {
    "id": "21",
    "name": "Wollen Sweater",
    "description": "wollen Sweater made from wool and with inner attached in it",
    "brand": "ShadeMaster",
    "size1": "One Size",
    "color1": "Black",
    "color2": "Tortoise",
    "image": "cap.avif",
    "price": "1499"
  },
  {
    "id": "22",
    "name": "Beach Towel",
    "description": "Relax by the beach with our soft and absorbent beach towel.",
    "brand": "BeachEssentials",
    "size1": "One Size",
    "color1": "Striped",
    "color2": "Patterned",
    "image": "Beach Towel.jpg",
    "price": "2499"
  },
  {
    "id": "23",
    "name": "Cotton Tank Top",
    "description": "Stay cool and comfortable with our cotton tank top.",
    "brand": "CoolBreeze",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "White",
    "color2": "Gray",
    "image": "Cotton Tank Top.jpg",
    "price": "1999"
  },
  {
    "id": "24",
    "name": "Flip Flops",
    "description": "Slip into comfort with our stylish flip flops.",
    "brand": "BeachLife",
    "size1": "US 5-10",
    "color1": "Blue",
    "color2": "Pink",
    "image": "Flip Flops.jpg",
    "price": "999"
  },
  {
    "id": "25",
    "name": "Swimsuit",
    "description": "Dive into style with our flattering swimsuit.",
    "brand": "BeachGlam",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Red",
    "color2": "Black",
    "image": "Swimsuit.jpg",
    "price": "4999"
  },
  {
    "id": "26",
    "name": "Lightweight Shorts",
    "description": "Stay comfortable in the heat with our lightweight shorts.",
    "brand": "SummerEase",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Khaki",
    "color2": "Olive",
    "image": "Lightweight Shorts.jpg",
    "price": "3499"
  },
  {
    "id": "27",
    "name": "Cotton Sundress",
    "description": "Enjoy the sun in our breezy cotton sundress.",
    "brand": "SunnyStyle",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Yellow",
    "color2": "Floral",
    "image": "Cotton Sundress.jpg",
    "price": "4499"
  },
  {
    "id": "28",
    "name": "Straw Hat",
    "description": "Complete your beach look with our chic straw hat.",
    "brand": "BeachChic",
    "size1": "One Size",
    "color1": "Natural",
    "color2": "Beige",
    "image": "Straw Hat.jpg",
    "price": "2499"
  },
  {
    "id": "29",
    "name": "Lightweight Tank Top",
    "description": "Stay cool and casual with our lightweight tank top.",
    "brand": "SummerBreeze",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Blue",
    "color2": "Green",
    "image": "Lightweight Tank Top.jpg",
    "price": "1499"
  },
  {
    "id": "30",
    "name": "Beach Bag",
    "description": "Carry your essentials in style with our spacious beach bag.",
    "brand": "BeachEssentials",
    "size1": "One Size",
    "color1": "Striped",
    "color2": "Patterned",
    "image": "Beach Bag.jpg",
    "price": "2999"
  },
  {
    "id": "31",
    "name": "Sari",
    "description": "Traditional Nepali sari, perfect for cultural events and celebrations.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Blue",
    "color2": "Pink",
    "image": "Nepali Sari.avif",
    "price": "2399",
    "price2": "2999",
    "discount": "15%" // Specific discount of 15%
  },
  {
    "id": "32",
    "name": "Daura Sural",
    "description": "Authentic Nepali daura sural, ideal for formal occasions and ceremonies.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Red",
    "color2": "Yellow",
    "image": "Nepali Daura Sural.png",
    "price": "2799",
    "price2": "3499",
    "discount": "20%" // Specific discount of 20%
  },
  {
    "id": "33",
    "name": "Coat",
    "description": "Stylish Nepali coat, suitable for both casual and formal wear.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Green",
    "color2": "Purple",
    "image": "Nepali Coat.webp",
    "price": "3199",
    "price2": "3999",
    "discount": "12%" // Specific discount of 12%
  },
  {
    "id": "34",
    "name": "Kurta",
    "description": "Classic Nepali kurta, perfect for everyday wear or special occasions.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Orange",
    "color2": "Black",
    "image": "Nepali Kurta.jpg",
    "price": "3599",
    "price2": "4499",
    "discount": "10%" // Specific discount of 10%
  },
  {
    "id": "1",
    "name": "Cozy Knit Sweater",
    "description": "Stay warm and stylish with our cozy knit sweater.",
    "brand": "WarmWool",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "size4": "XL",
    "color1": "Darkslategray",
    "color2": "Tomato",
    "image": "Cozy Knit Sweater.jpg",
    "price": "4999"
  },
  {
    "id": "2",
    "name": "Faux Fur Coat",
    "description": "Make a statement with our luxurious faux fur coat.",
    "brand": "FurFashion",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Black",
    "color2": "Mistyrose",
    "image": "Faux Fur Coat.jpg",
    "price": "8999"
  },
  {
    "id": "3",
    "name": "Plaid Flannel Shirt",
    "description": "Classic plaid flannel shirt for a timeless look.",
    "brand": "RusticWear",
    "size1": "M",
    "size2": "L",
    "size3": "XL",
    "color1": "Darkolivegreen",
    "color2": "Darkgoldenrod",
    "image": "Plaid Flannel Shirt.avif",
    "price": "3499"
  },
  {
    "id": "4",
    "name": "Chunky Cable-Knit Scarf",
    "description": "Stay cozy with our chunky cable-knit scarf.",
    "brand": "WinterWarmth",
    "size1": "One Size",
    "color1": "Saddlebrown",
    "color2": "Steelblue",
    "image": "Chunky Cable-Knit Scarf.jpg",
    "price": "2499"
  },
  {
    "id": "5",
    "name": "Puffer Jacket",
    "description": "Stay warm and dry with our water-resistant puffer jacket.",
    "brand": "AllWeather",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "size4": "XL",
    "color1": "Dodgerblue",
    "color2": "Khaki",
    "image": "Puffer Jacket.jpg",
    "price": "7999"
  },
  {
    "id": "6",
    "name": "Thermal Long Johns",
    "description": "Keep the cold out with our thermal long johns.",
    "brand": "WinterBasics",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Lightgrey",
    "color2": "Maroon",
    "image": "Thermal Long Johns.jpg",
    "price": "2999"
  },
  {
    "id": "7",
    "name": "Beanie Hat",
    "description": "Top off your winter look with our cozy beanie hat.",
    "brand": "HeadWarmers",
    "size1": "One Size",
    "color1": "Gold",
    "color2": "Dimgray",
    "image": "Beanie Hat.jpg",
    "price": "1499"
  },
  {
    "id": "8",
    "name": "Insulated Gloves",
    "description": "Protect your hands from the cold with our insulated gloves.",
    "brand": "ColdDefenders",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Green",
    "color2": "Magenta",
    "image": "Insulated Gloves.jpg",
    "price": "1999"
  },
  {
    "id": "9",
    "name": "Wool Blend Coat",
    "description": "Stay elegant and warm with our wool blend coat.",
    "brand": "WinterChic",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Purple",
    "color2": "Wheat",
    "image": "Wool Blend Coat.jpg",
    "price": "9999"
  },
  {
    "id": "10",
    "name": "Snow Boots",
    "description": "Conquer the snow with our durable and waterproof snow boots.",
    "brand": "SnowMaster",
    "size1": "US 6-12",
    "color1": "Teal",
    "color2": "Gold",
    "image": "Snow Boots.jpg",
    "price": "5999"
  },
  {
    "id": "11",
    "name": "Fleece-lined Leggings",
    "description": "Stay warm and cozy with our fleece-lined leggings.",
    "brand": "WinterEssentials",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Rebeccapurple",
    "color2": "Lightseagreen",
    "image": "Fleece-lined Leggings.jpg",
    "price": "1999"
  },
  {
    "id": "12",
    "name": "Quilted Vest",
    "description": "Add a layer of warmth with our quilted vest.",
    "brand": "VersatileWear",
    "size1": "M",
    "size2": "L",
    "size3": "XL",
    "color1": "Blueviolet",
    "color2": "Deeppink",
    "image": "Quilted Vest.jpg",
    "price": "4999"
  },
  {
    "id": "13",
    "name": "Cashmere Sweater",
    "description": "Indulge in luxury with our soft and cozy cashmere sweater.",
    "brand": "LuxuryKnits",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Midnightblue",
    "color2": "Darkturquoise",
    "image": "Cashmere Sweater.avif",
    "price": "12999"
  },
  {
    "id": "14",
    "name": "Sherpa-Lined Jacket",
    "description": "Stay toasty in our sherpa-lined jacket with a rugged exterior.",
    "brand": "OutdoorStyle",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Indigo",
    "color2": "Limegreen",
    "image": "Sherpa-Lined Jacket.jpg",
    "price": "6999"
  },
  {
    "id": "15",
    "name": "Mittens",
    "description": "Keep your hands warm with our cozy mittens.",
    "brand": "HandWarmers",
    "size1": "One Size",
    "color1": "Darkolivegreen",
    "color2": "Peru",
    "image": "Mittens.jpg",
    "price": "1299"
  },
  {
    "id": "16",
    "name": "Wool Socks",
    "description": "Stay comfortable all day with our soft and warm wool socks.",
    "brand": "SockCozy",
    "size1": "One Size",
    "color1": "Maroon",
    "color2": "Teal",
    "image": "Wool Socks.jpg",
    "price": "999"
  },
  {
    "id": "35",
    "name": "Sherwani",
    "description": "Elegant Nepali sherwani, suitable for weddings and formal gatherings.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "White",
    "color2": "Gray",
    "image": "Nepali Sherwani.avif",
    "price": "3999",
    "price2": "4999",
    "discount": "20%" // Specific discount of 20%
  },
  {
    "id": "36",
    "name": "Bakhu",
    "description": "Traditional Nepali bakhu, ideal for cultural events and festivals.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Brown",
    "color2": "Cyan",
    "image": "Nepali Bakhu.jpg",
    "price": "4399",
    "price2": "5499",
    "discount": "15%" // Specific discount of 15%
  },
  {
    "id": "37",
    "name": "kurtha",
    "description": "Stylish Nepali kurtha, suitable for traditional and contemporary occasions.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Beige",
    "color2": "Maroon",
    "image": "kurtha.webp",
    "price": "4799",
    "price2": "5999",
    "discount": "10%" // Specific discount of 10%
  },
  {
    "id": "38",
    "name": "Topi",
    "description": "Authentic Nepali topi, perfect for cultural events and everyday wear.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Navy",
    "color2": "Olive",
    "image": "Nepali Topi.jpg",
    "price": "519",
    "price2": "649",
    "discount": "20%" // Specific discount of 20%
  }
];
